import {
  DecoratorNode,
  DOMExportOutput,
  LexicalNode,
  NodeKey,
  SerializedLexicalNode,
  Spread,
  LexicalCommand,
  createCommand,
  $getSelection,
  $isRangeSelection,
  $insertNodes,
  $isRootOrShadowRoot,
  $createParagraphNode,
} from 'lexical';
import { $wrapNodeInElement } from '@lexical/utils';
import React from 'react';

export type SerializedPageBreakNode = Spread<
  {
    type: 'page-break';
    version: 1;
  },
  SerializedLexicalNode
>;

export const INSERT_PAGE_BREAK_COMMAND: LexicalCommand<void> = createCommand('INSERT_PAGE_BREAK_COMMAND');

function PageBreakComponent(): React.ReactElement {
  return (
    <div className="page-break-node" contentEditable={false}>
      <span className="page-break-label">Page Break</span>
    </div>
  );
}

export class PageBreakNode extends DecoratorNode<React.ReactElement> {
  static getType(): string {
    return 'page-break';
  }

  static clone(node: PageBreakNode): PageBreakNode {
    return new PageBreakNode(node.__key);
  }

  static importJSON(_serializedNode: SerializedPageBreakNode): PageBreakNode {
    return $createPageBreakNode();
  }

  constructor(key?: NodeKey) {
    super(key);
  }

  exportJSON(): SerializedPageBreakNode {
    return {
      type: 'page-break',
      version: 1,
    };
  }

  createDOM(): HTMLElement {
    const div = document.createElement('div');
    div.className = 'page-break-wrapper';
    return div;
  }

  updateDOM(): false {
    return false;
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement('div');
    element.className = 'page-break-node';
    element.setAttribute('data-page-break', 'true');
    element.style.pageBreakAfter = 'always';
    element.style.breakAfter = 'page';
    return { element };
  }

  getTextContent(): string {
    return '\n';
  }

  isInline(): false {
    return false;
  }

  decorate(): React.ReactElement {
    return <PageBreakComponent />;
  }
}

export function $createPageBreakNode(): PageBreakNode {
  return new PageBreakNode();
}

export function $isPageBreakNode(node: LexicalNode | null | undefined): node is PageBreakNode {
  return node instanceof PageBreakNode;
}

export function $insertPageBreak(): void {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return;
  }
  
  const pageBreakNode = $createPageBreakNode();
  $insertNodes([pageBreakNode]);
  
  if ($isRootOrShadowRoot(pageBreakNode.getParentOrThrow())) {
    $wrapNodeInElement(pageBreakNode, $createParagraphNode).selectEnd();
  }
}
